export default "__VITE_ASSET__DeZfXKNw__"